export { default as PopupWrapper, type PopupVariant } from "./PopupWrapper";
